import { Module } from 'vuex'
import { WishlistState } from '../types/WishlistState'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'
import { state } from './state'

export const module: Module<WishlistState, any> = {
  namespaced: true,
  mutations,
  actions,
  getters,
  state
}
